<template>
  <v-card>
    <v-card-title>
      Delete {{modalType}}
    </v-card-title>
    <v-card-text>
      <v-alert color="error" icon="warning" v-if="err" :value="err !== ''">
        {{err}}
      </v-alert>
      Are you sure you want to delete the {{modalType}}?
    </v-card-text>
  <v-card-actions>
    <v-layout column align-end class="px-2">
      <a
        @click.prevent="submit"
        class="modal-button black--text"
        :disabled="!valid">
        <v-btn :disabled="!valid" fab dark small color="primary">
          <v-icon dark>arrow_forward</v-icon>
        </v-btn>
        Delete
      </a>  
      <a
        @click.prevent="$emit('close')"
        class="modal-button black--text">
        <v-btn fab dark small color="accent">
          <v-icon dark>close</v-icon>
        </v-btn>
        Close
      </a>
    </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
  import webHelper from '../../helpers/web';

  export default {
    props: ['modalType', 'id', 'path'],
    data: () => ({
      err: '',
    }),
    methods: {
      async submit() {
        this.err = '';
        const res = await webHelper.delete(this, this.path, { id: this.id });
        if (res.failed) {
          this.err = `Failed to delete the ${this.modalType}`;
          return;
        }
        this.$emit('submit');
      },
    },
  };
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modals/Delete.vue